// Guarded relative-date formatter shared across chat/document/report/proposal tiles.
// Never render `new Date(x).toLocaleDateString()` directly on a possibly-missing or
// malformed field — it renders the literal string "Invalid Date" to the user.
export function formatRelativeDate(date: Date | string | null | undefined): string {
  if (!date) {
    return 'Unknown date';
  }

  const dateObj = date instanceof Date ? date : new Date(date);

  if (isNaN(dateObj.getTime())) {
    return 'Unknown date';
  }

  const now = new Date();
  const diffTime = now.getTime() - dateObj.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays >= 0 && diffDays < 7) return `${diffDays} days ago`;

  return dateObj.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: dateObj.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
  });
}
